import { UtskriftTyp, VKKontraktUtskriftDTO } from "./utskrift-models";

export interface IKontraktSigneringRequestDTO {
  primaryDokumentTyp?: string;
  utvaldaUtskrifter: VKKontraktUtskriftDTO[];
  utvaldaLeverantorer: IKontraktSigneringLeverantor[];
  giltigAntalDagar?: number;
}

export interface IKontraktSigneringLeverantor {
  leverantorGuid: string;
  namn: string;
  persOrgNummer: string;
  epost: string;
  telefon: string;
  shouldSendMakeMaka: boolean;
  makeMakaNamn: string;
  makeMakaEpost: string;
  makeMakaSigneringsmetod: string;
  makeMakaSmsNummer: string;
  signeringsmetod: string;
  smsNummer: string;
  alternativKontaktperson: boolean;
  deltagarTyp: string;
  inbjudningsOrdning: number;
}

type DigitalSigneringDokumentFilter = {
  bilagor: UtskriftTyp[];
  utskrifter: UtskriftTyp[];
};

type DigitalSigneringDokumentFilterDict = {
  [key in UtskriftTyp]?: DigitalSigneringDokumentFilter;
};

export const dokumentExcludeDict: DigitalSigneringDokumentFilterDict = {
    Kontrakt: {
        bilagor: [],
        utskrifter: [
            "SkogsvardsKontrakt",
            "Kontrakt-skogsvardsSammanstallning"
        ]
    },
    SkogsvardsKontrakt: {
        bilagor: [
            "Kontrakt-betalplan",
            "Kontrakt-karta"
        ],
        utskrifter: ["Kontrakt"]
    }
};
